import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from "components/CustomButtons/Button.jsx";
import Config from "../../config/";
const ROOT_URL = Config.rooturl;

class Portdt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: false,
          display: false
        }
      },
      {
        label: "Name",
        name: "name",
        options: {
          filter: true
        }
      },
      {
        label: "Address",
        name: "address",
        options: {
          filter: true
        }
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: true
        }
      },
      {
        label: "District",
        name: "district",
        options: {
          filter: true
        }
      },
      {
        label: "Dimensi",
        name: "dimensi",
        options: {
          filter: true
        }
      },
      {
        label: "Latitude",
        name: "latitude",
        options: {
          filter: true
        }
      },
      {
        label: "Longitude",
        name: "longitude",
        options: {
          filter: true
        }
      },
      // {
      //   label: "Description",
      //   name: "urlfile",
      //   options: {
      //     filter: true,
      //     customBodyRender: val => (
      //       <a href = {`${ROOT_URL}${val}`} download>
      //         {val}
      //       </a>
      //     )
      //   }
      // },

      {
        name: "Action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            let id = tableMeta.rowData !== undefined ? tableMeta.rowData[0] : 0;
            if(localStorage.getItem('userlevel') != 3){
              return (
                <div>
                  <Button
                    color="behance"
                    round
                    onClick={() => this.props.handleUpdate(id)}
                  >
                    Update
                  </Button>
                  <Button
                    color="danger"
                    round
                    onClick={() => this.props.handleDelete(id)}
                  >
                    Delete
                  </Button>
                </div>
              );
            }else{
              return (<div/>)
            }
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.props.loader ? "Searching..." : "Sorry, no matching records found"
        }
      }
    };

    return (
      <MUIDataTable
        title={"Port"}
        data={this.props.datatable}
        columns={columns}
        options={options}
      />
    );
  }
}

export default Portdt;
